// 系统配置文件
const config = {
  // 开发环境配置
  development: {
    // API基础地址
    baseAPI: process.env.VUE_APP_BASE_API || "http://47.122.128.144:9906",
    // 上传服务器地址
    uploadServer:
      process.env.VUE_APP_UPLOAD_SERVER || "http://47.122.128.144:9906/upload/",
    // 其他配置
    timeout: 15000,
    debug: true,
  },

  // 生产环境配置
  production: {
    baseAPI: process.env.VUE_APP_BASE_API || "/api", // 对应后端接口根路径
    uploadServer: process.env.VUE_APP_UPLOAD_SERVER || "/upload/", // 上传路径
    timeout: 15000,
    debug: false,
  },
};

// 根据当前环境获取配置
const env = process.env.NODE_ENV || "development";
const currentConfig = config[env];

// 导出配置
export default currentConfig;

// 导出特定配置项，方便使用
export const { baseAPI, imageServer, uploadServer, timeout, debug } =
  currentConfig;
